

export default {
    FETCH_USER: 'FETCH_USER',
    AUTHENTICATED: 'AUTHENTICATED',
    PUBKEY: 'PUBKEY',

    SHOW_VERSION_REQUEST: 'SHOW_VERSION_REQUEST',
    SHOW_VERSION_SUCCESS: 'SHOW_VERSION_SUCCESS',
    SHOW_VERSION_FAILURE: 'SHOW_VERSION_FAILURE',

    NO_TOKEN_FOUND: 'NO_TOKEN_FOUND',

    RENEW_TOKENS_REQUEST:  'RENEW_TOKENS_REQUEST',
    RENEW_TOKENS_RETRY:   'RENEW_TOKENS_RETRY',
    RENEW_TOKENS_SUCCESS: 'RENEW_TOKENS_SUCCESS',
    RENEW_TOKENS_FAILURE: 'RENEW_TOKENS_FAILURE',

    LOAD_CONFIG_REQUEST: 'LOAD_CONFIG_REQUEST',
    LOAD_CONFIG_SUCCESS: 'LOAD_CONFIG_SUCCESS',
    LOAD_CONFIG_FAILURE: 'LOAD_CONFIG_FAILURE',

    LOGIN_REQUEST: 'LOGIN_REQUEST',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGIN_FAILURE: 'LOGIN_FAILURE',

    LOAD_OCI_INSTANCES_REQUEST: 'LOAD_OCI_INSTANCES_REQUEST',
    LOAD_OCI_INSTANCES_SUCCESS: 'LOAD_OCI_INSTANCES_SUCCESS',
    LOAD_OCI_INSTANCES_FAILURE: 'LOAD_OCI_INSTANCES_FAILURE',

    LOAD_USER_DATA_REQUEST: 'LOAD_USER_DATA_REQUEST',
    LOAD_USER_DATA_SUCCESS: 'LOAD_USER_DATA_SUCCESS',
    LOAD_USER_DATA_FAILURE: 'LOAD_USER_DATA_FAILURE',

    LOAD_CLUSTER_LOCATIONS_REQUEST: 'LOAD_CLUSTER_LOCATIONS_REQUEST',
    LOAD_CLUSTER_LOCATIONS_SUCCESS: 'LOAD_CLUSTER_LOCATIONS_SUCCESS',
    LOAD_CLUSTER_LOCATIONS_FAILURE: 'LOAD_CLUSTER_LOCATIONS_FAILURE',

    LOAD_USER_AND_LOCATIONS_REQUEST: 'LOAD_USER_AND_LOCATIONS_REQUEST',
    LOAD_USER_AND_LOCATIONS_SUCCESS: 'LOAD_USER_AND_LOCATIONS_SUCCESS',
    LOAD_USER_AND_LOCATIONS_FAILURE: 'LOAD_USER_AND_LOCATIONS_FAILURE',

    GET_TENANT_STATUS_REQUEST: 'GET_TENANT_STATUS_REQUEST',
    GET_TENANT_STATUS_SUCCESS: 'GET_TENANT_STATUS_SUCCESS',
    GET_TENANT_STATUS_FAILURE: 'GET_TENANT_STATUS_FAILURE',

    CREATE_OCI_INSTANCES_REQUEST: 'CREATE_OCI_INSTANCES_REQUEST',
    CREATE_OCI_INSTANCES_SUCCESS: 'CREATE_OCI_INSTANCES_SUCCESS',
    CREATE_OCI_INSTANCES_FAILURE: 'CREATE_OCI_INSTANCES_FAILURE',

    REMOVE_OCI_INSTANCES_REQUEST: 'REMOVE_OCI_INSTANCES_REQUEST',
    REMOVE_OCI_INSTANCES_SUCCESS: 'REMOVE_OCI_INSTANCES_SUCCESS',
    REMOVE_OCI_INSTANCES_FAILURE: 'REMOVE_OCI_INSTANCES_FAILURE',

    UPDATE_OCI_INSTANCES_REQUEST: 'UPDATE_OCI_INSTANCES_REQUEST',
    UPDATE_OCI_INSTANCES_SUCCESS: 'UPDATE_OCI_INSTANCES_SUCCESS',
    UPDATE_OCI_INSTANCES_FAILURE: 'UPDATE_OCI_INSTANCES_FAILURE',

    SECURITY_INVALID_DOMAIN: 'SECURITY_INVALID_DOMAIN',
    CLEAR_OCI_ERROR: 'CLEAR_OCI_ERROR',

    LOAD_USER_PROFILE_REQUEST: 'LOAD_USER_PROFILE_REQUEST',
    LOAD_USER_PROFILE_SUCCESS: 'LOAD_USER_PROFILE_SUCCESS',
    LOAD_USER_PROFILE_FAILURE: 'LOAD_USER_PROFILE_FAILURE',

    CREATE_OCI_USER_TOKEN_REQUEST: 'CREATE_OCI_USER_TOKEN_REQUEST',
    CREATE_OCI_USER_TOKEN_SUCCESS: 'CREATE_OCI_USER_TOKEN_SUCCESS',
    CREATE_OCI_USER_TOKEN_FAILURE: 'CREATE_OCI_USER_TOKEN_FAILURE',

    //invitation
    ACCEPT_INVITATION_REQUEST: 'ACCEPT_INVITATION_REQUEST',
    ACCEPT_INVITATION_SUCCESS: 'ACCEPT_INVITATION_SUCCESS',
    ACCEPT_INVITATION_FAILURE: 'ACCEPT_INVITATION_FAILURE',

    //Multi Regions
    SET_TENANT_LOCATION: 'SET_TENANT_LOCATION',
    SET_TENANT_LOCATION_FAILURE: 'SET_TENANT_LOCATION_FAILURE',

    //Sign up
    LOAD_USER_SIGNUP_INFO: 'LOAD_USER_SIGNUP_INFO',
    SET_FULL_NAME: 'SET_FULL_NAME',
    SET_WORKL_EMAIL: 'SET_WORKL_EMAIL',
    SET_COMPANY_NAME: 'SET_COMPANY_NAME',
    SET_PHONE_NUMBER: 'SET_PHONE_NUMBER',
    SET_JOB_ROLE: 'SET_JOB_ROLE',
    SET_COUNTRY: 'SET_COUNTRY',
    SET_ZIP_CODE: 'SET_ZIP_CODE',
    SET_TOTAL_NUMBER_PHYSICAL_VIRTUAL_HOSTS: 'SET_TOTAL_NUMBER_PHYSICAL_VIRTUAL_HOSTS',
    SET_STORAGE_CAPACITY: 'SET_STORAGE_CAPACITY',
    SET_OPTION_INFO_GEN: 'SET_OPTION_INFO_GEN',

    SET_SIGNUP_INFO_REQUEST: 'SET_SIGNUP_INFO_REQUEST',
    SET_SIGNUP_INFO_SUCCESS: 'SET_SIGNUP_INFO_SUCCESS',
    SET_SIGNUP_INFO_FAILURE: 'SET_SIGNUP_INFO_FAILURE',

    START_FREE_TRIAL: 'START_FREE_TRIAL',
}
